<template>
  <li class="teacon-list-item">
    <slot></slot>
  </li>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'teacon-list-item'
  })
</script>

<style>
.teacon-list-item {
  @apply relative before:(content-none absolute -left-5 top-2.5 w-2 h-2 rounded-sm bg-gradient-to-br from-red-400 to-red-500 ring-2 ring-red-200 ring-offset-2 ring-offset-milky transform rotate-45);
}
.teacon-faqs-item-wrap.answer .teacon-list-item {
  @apply before:ring-offset-gray-200;
}
</style>
